import { useClientSide } from '@carvana/merch-react-hooks';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import GeoModal from '@/common/helios/Modals/GeoModal';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useModalContext } from '~/context/new-cars/ModalContext';
import fetchSearchV1Delivery from '~/services/common/fetchSearchV1Delivery';

export default function GeolocationModal() {
  const { isGeolocationModalOpen, setGeolocationModalOpen } = useModalContext();
  const router = useRouter();
  const isClientSide = useClientSide();
  const trackEvent = useTrackEvent();

  const fetchDelivery = useCallback(
    (zip: string) => fetchSearchV1Delivery(zip, 'new'),
    []
  );

  const onSuccessfulZipChange = useCallback(() => {
    router.refresh();
  }, [router]);

  if (!isClientSide) return null;

  return (
    <GeoModal
      fetchDelivery={fetchDelivery}
      isGeolocationModalOpen={isGeolocationModalOpen}
      onSuccessfulZipChange={onSuccessfulZipChange}
      setGeolocationModalOpen={setGeolocationModalOpen}
      trackEvent={trackEvent}
    />
  );
}
